/**
 *  Some common constants useful for Ethereum.
 *
 *  @_section: api/constants: Constants  [about-constants]
 */

export { ZeroAddress } from "./addresses.js";
export { ZeroHash } from "./hashes.js";
export {
    N,
    WeiPerEther,
    MaxUint256,
    MinInt256,
    MaxInt256
} from "./numbers.js";
export { EtherSymbol, MessagePrefix } from "./strings.js";
